import React, { useEffect, useState, useMemo, useRef } from "react";
import { color } from "../../../StyleData/Config";
import {
  Grid,
  Typography,
  Paper,
  Select,
  MenuItem,
  TextField,
  Box,
  Divider,
  IconButton,
  Tab,
  Autocomplete,
  CircularProgress,
  createFilterOptions,
  Button,
} from "@mui/material";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { axiosPrivate, siteInfo } from "../../../axios/axios";
import { masterAPI } from "../../Masters/dataConfig";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  DatePicker,
  renderTimeViewClock,
  DateTimePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import moment from "moment";
import { Add, ArrowBack, PlaylistAdd } from "@mui/icons-material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import ErrorProps from "../../../Component/Errorprops";
import { toast } from "react-toastify";
import { encode } from "../../../Component/JWT/Formatt";
import { defaultInfo } from "../../../ConfigInfo/Info";
import {
  fromUTC,
  toUTC,
  getCurrentInTimeZone,
  getDateWithOutUTC,
} from "../../../utils/dateUtil";

const CreateGeneral = () => {
  const navigate = useNavigate();

  const editData = useSelector(
    (state) => state.editData.workOrderEditData.data,
  );
  const worktypCM = useSelector((state) => state.editData.workTypeData.data);
  const edit = useSelector((state) => state.editData.workOrderEditData.edit);
  console.log("worktypCM", worktypCM);
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);
  console.log("editData", editData);

  const [locationId, setLocationId] = useState([]);
  const [assetId, setAssetId] = useState([]);
  const [assetsList, setAssetsList] = useState([]);
  console.log("Assets", assetId);
  const [JPStatus, setJPStatus] = useState([]);
  const [priorityJob, setPriorityJob] = useState([]);
  const [jobPlan, setJobPlan] = useState([]);
  const [requestByUser, setRequestByUser] = useState([]);
  const [personData, setPersonData] = useState([]);
  const [businessData, setBusinessData] = useState([]);
  const [value, setValue] = useState("1");
  const [failureClass, setFailureClass] = useState([]);
  const [priority, setPriority] = useState([]);
  // const [site,setSite]=useState([])
  const [workType, setWorkType] = useState([]);
  const [workOrderByStatus, setWorkOrderByStatus] = useState([]);
  const [pmWorkTypeId, setPmWorkTypeId] = useState("");
  const [probleCode, setProblemCode] = useState([]);
  const [loading, setLoading] = useState(false);
  const [workTypeSelect, setWorkTypeSelect] = useState({
    workType: null,
    priority: null,
  });
  const [auto, setAuto] = useState({
    asset: edit ? editData.assetCode + " - " + editData.assetName : "",
    location: edit ? editData.locationCode + " - " + editData.locationName : "",
  });
  const [assetInfo, setAssetInfo] = useState({});
  const [defaultWorkTypeId, setdefaultWorkTypeId] = useState("");

  const formikRef = useRef();
  useEffect(() => {
    if (formikRef.current) {
      const formikCurrent = formikRef.current;
      formikCurrent.setFieldValue(
        "priorityId",
        formikCurrent.values.priorityId === null
          ? workTypeSelect.priority
          : formikCurrent.values.priorityId,
      );
      formikCurrent.setFieldValue(
        "workTypeId",
        formikCurrent.values.workTypeId === null
          ? workTypeSelect.workType
          : formikCurrent.values.workTypeId,
      );
    }
  }, [workTypeSelect]);
  const [workCenters, setWorkCenters] = useState([]);

  useEffect(() => {
    getDataList();
    // Fetch work centers
    axiosPrivate
      .get("/selectlist/getallworkcenters")
      .then((res) => {
        setWorkCenters(res.data);
      })
      .catch(() => setWorkCenters([]));
  }, []);

  const getDataList = async () => {
    setLoading(true);
    getData();
    const locationLink = masterAPI["location"].link;
    await axiosPrivate
      .get(`${locationLink}`)
      .then((res) => {
        console.log(res.data.result);
        setLocationId(res.data.result);
      })
      .catch((e) => {
        setLocationId([]);
        console.log(e, "createwo locaion getall");
      });

    //   const siteLink=masterAPI["site"].link
    //  await axiosPrivate.get(`${siteLink}`).then(res=>{
    //     console.log(res.data.result)
    //     setSite(res.data.result)
    // }).catch(e=>{
    //     setSite([])
    //     console.log(e,"createwo locaion getall")
    // })

    const jobPlanStatusLink = masterAPI["selectList"].woStatus;
    await axiosPrivate
      .get(`${jobPlanStatusLink}`)
      .then((res) => {
        console.log(res.data);
        setJPStatus(res.data);
      })
      .catch((e) => {
        setJPStatus([]);
        console.log(e, "getJOBPlanStatus Create Wo");
      });
    const jobPriorityLink = masterAPI["selectList"].jobPriority;
    await axiosPrivate
      .get(`${jobPriorityLink}`)
      .then((res) => {
        console.log(res.data);
        setPriorityJob(res.data);
      })
      .catch((e) => {
        setPriorityJob([]);
        console.log(e, "getPriority Create Wo");
      });
    const jobplanLink = masterAPI["jobPlan"].link;
    await axiosPrivate
      .get(`${jobplanLink}`)
      .then((res) => {
        console.log(res.data.result);
        setJobPlan(res.data.result);
      })
      .catch((e) => {
        setJobPlan([]);
        console.log(e, "getJobPlan Create Wo");
      });
    //////////////User getUserBysite/////////////////////
    const getUserLink = masterAPI["user"].getUserBySite;
    await axiosPrivate
      .get(`${getUserLink}/2b143042-85e1-4edb-be93-ddfc87905275`)
      .then((res) => {
        console.log(res.data.result);
        setRequestByUser(res.data.result);
      })
      .catch((e) => {
        setRequestByUser([]);
        console.log(e, "requesByUser Create Wo");
      });

    ////////////// labour /////////////////////
    const labourLink = masterAPI["labour"].link;
    await axiosPrivate
      .get(`${labourLink}`)
      .then((res) => {
        console.log(res.data.result);
        setPersonData(res.data.result);
      })
      .catch((e) => {
        setPersonData([]);
        console.log(e, "labour Create Wo");
      });

    ////////////// Business /////////////////////
    const businessLink = masterAPI["business"].link;
    await axiosPrivate
      .get(`${businessLink}`)
      .then((res) => {
        console.log(res.data.result);
        setBusinessData(res.data.result);
      })
      .catch((e) => {
        setBusinessData([]);
        console.log(e, "business Create Wo");
      });
    /////////////failureClass///////////////////////////

    const fcLink = masterAPI["failureClass"].link;
    await axiosPrivate
      .get(`${fcLink}`)
      .then((res) => {
        console.log(res.data.result);
        setFailureClass(res.data.result);
      })
      .catch((e) => {
        setFailureClass([]);
        console.log(e, "failureClass Create Wo");
      });
    if (edit) {
      /////////////////////////problem Code//////////////////
      const pcLink = masterAPI["problems"].problembyFailureClass;
      await axiosPrivate
        .get(`${pcLink}/${editData.failureClassId}`)
        .then((res) => {
          console.log(res.data.result);
          setProblemCode(res.data.result);
        })
        .catch((e) => {
          setProblemCode([]);
          console.log(e, "Problem Create Wo");
        });
    }
    //////////////////priority////////////////////////////////////////
    const priLink = masterAPI["priority"].link;
    await axiosPrivate
      .get(`${priLink}`)
      .then((res) => {
        console.log(res.data.result);
        setWorkTypeSelect({
          ...workTypeSelect,
          priority: res.data.result[0].id,
        });
        setPriority(res.data.result);
      })
      .catch((e) => {
        setPriority([]);
        console.log(e, "failureClass Create Wo");
      });
    ////////////////workordertype/////////////////
    const wotypeLink = masterAPI["selectList"].workordertype;
    await axiosPrivate
      .get(
        `${wotypeLink}?WorktypeforPM=${edit && editData.pmCode ? true : false}`,
      )
      .then((res) => {
        // const filteredWorkTypes = res.data.filter((item) => {
        //   if (edit  && editData.pmCode) {
        //     return item.text.split("-")[0].trim()+"-"+item.text.split("-")[1].trim() !== defaultInfo.workType.PM_INS;
        //   }
        //   return item.text.split("-")[0].trim() !== defaultInfo.workType.PM && item.text.split("-")[0].trim()+"-"+item.text.split("-")[1].trim() !== defaultInfo.workType.PM_INS;
        // });
        setWorkTypeSelect({ ...workTypeSelect, workType: res.data[0].value });
        setWorkType(res.data);
        console.log("worktype", res.data);

        // const defaultWorkTypeIdtest = res.data.find((item) => item.text === "CM")?.value;
        // const pmWorkTypeIdTest = res.data.find((item) => item.text === "PM")?.value;
        // setPmWorkTypeId(pmWorkTypeIdTest);
        // setdefaultWorkTypeId(defaultWorkTypeIdtest);
        console.log("test", defaultWorkTypeId);
      })
      .catch((e) => {
        setWorkType([]);
        console.log(e, "work type Create Wo");
      });

    ////////////////workOrderByStatus/////////////////
    const workOrderByStatusLink = masterAPI["selectList"].workordersbyStatus;
    await axiosPrivate
      .get(`${workOrderByStatusLink}/COMP`)
      .then((res) => {
        console.log("workOrderByStatus", res.data);
        setWorkOrderByStatus(res.data);
      })
      .catch((e) => {
        setWorkOrderByStatus([]);
        console.log(e, "workOrderByStatus Create Wo");
      });

    setLoading(false);
  };

  const getData = async () => {
    const assetLink = masterAPI["assets"].link;
    await axiosPrivate
      .get(`${assetLink}`)
      .then((res) => {
        console.log("Assets", res.data.result);
        const filterDataByAssetStatus = res.data.result.filter(
          (item) =>
            item.statusName !== "Decomissioned" &&
            item.statusName !== "Missing",
        );
        setAssetId(filterDataByAssetStatus);
        setAssetsList(filterDataByAssetStatus);
      })
      .catch((e) => {
        setAssetId([]);
        setAssetsList([]);
        console.log(e, "createwo asset getall");
      });
  };

  const handleCancel = () => {
    navigate("/workOrder");
  };

  const getValidWorkCenterId = (workCenters, initialId) => {
    // Filter out invalid options
    const validCenters = workCenters.filter(
      (center) => center.value && String(center.text).toLowerCase() !== "none",
    );
    // If initialId is valid, return it; otherwise, return null
    if (validCenters.some((center) => center.value === initialId)) {
      return initialId;
    }
    return null;
  };

  const initialValue = useMemo(
    () => ({
      description:
        editData.description !== "" &&
        editData.description !== undefined &&
        editData.description !== null
          ? editData.description
          : "",
      workOrderName:
        editData.workOrderName !== "" &&
        editData.workOrderName !== undefined &&
        editData.workOrderName !== null
          ? editData.workOrderName
          : "",
      locationId:
        editData.locationId !== "" &&
        editData.locationId !== undefined &&
        editData.locationId !== null
          ? editData.locationId
          : null,
      assetId:
        editData.assetId !== "" &&
        editData.assetId !== undefined &&
        editData.assetId !== null
          ? editData.assetId
          : null,
      status:
        editData.status !== "" &&
        editData.status !== undefined &&
        editData.status !== null
          ? editData.status
          : "NEW",
      failureClassId:
        editData.failureClassId !== "" &&
        editData.failureClassId !== undefined &&
        editData.failureClassId !== null
          ? editData.failureClassId
          : null,
      priorityId:
        editData.priorityId !== "" &&
        editData.priorityId !== undefined &&
        editData.priorityId !== null
          ? editData.priorityId
          : null,
      problemId:
        editData.problemId !== "" &&
        editData.problemId !== undefined &&
        editData.problemId !== null
          ? editData.problemId
          : null,
      siteId: siteInfoDetail.siteId,
      glAccount:
        editData.glAccount !== "" &&
        editData.glAccount !== undefined &&
        editData.glAccount !== null
          ? editData.glAccount
          : "",
      jobPlanId:
        editData.jobPlanId !== "" &&
        editData.jobPlanId !== undefined &&
        editData.jobPlanId !== null
          ? editData.jobPlanId
          : null,
      actualStartDate:
        editData.actualStartDate !== "" &&
        editData.actualStartDate !== undefined &&
        editData.actualStartDate !== null
          ? fromUTC(editData.actualStartDate).dayjsObject
          : null,
      actualEndDate:
        editData.actualEndDate !== "" &&
        editData.actualEndDate !== undefined &&
        editData.actualEndDate !== null
          ? fromUTC(editData.actualEndDate).dayjsObject
          : null,
      targetStartDate:
        editData.targetStartDate !== "" &&
        editData.targetStartDate !== undefined &&
        editData.targetStartDate !== null
          ? fromUTC(editData.targetStartDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject,
      targetEndDate:
        editData.targetEndDate !== "" &&
        editData.targetEndDate !== undefined &&
        editData.targetEndDate !== null
          ? fromUTC(editData.targetEndDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject.add(1, "days"),
      plannedStartDate:
        editData.plannedStartDate !== "" &&
        editData.plannedStartDate !== undefined &&
        editData.plannedStartDate !== null
          ? fromUTC(editData.plannedStartDate).dayjsObject
          : null,
      plannedEndDate:
        editData.plannedEndDate !== "" &&
        editData.plannedEndDate !== undefined &&
        editData.plannedEndDate !== null
          ? fromUTC(editData.plannedEndDate).dayjsObject
          : null,
      // stopBeginDate: getCurrentInTimeZone().dayjsObject,
      duration:
        editData.duration !== "" &&
        editData.duration !== undefined &&
        editData.duration !== null
          ? editData.duration
          : "1",
      earliestStartDate:
        editData.earliestStartDate !== "" &&
        editData.earliestStartDate !== undefined &&
        editData.earliestStartDate !== null
          ? fromUTC(editData.earliestStartDate).dayjsObject
          : null,
      latestEndDate:
        editData.latestEndDate !== "" &&
        editData.latestEndDate !== undefined &&
        editData.latestEndDate !== null
          ? fromUTC(editData.latestEndDate).dayjsObject
          : null,
      createdById:
        editData.createdById !== "" &&
        editData.createdById !== undefined &&
        editData.createdById !== null
          ? editData.createdById
          : null,
      createdDate:
        editData.createdDate !== "" &&
        editData.createdDate !== undefined &&
        editData.createdDate !== null
          ? fromUTC(editData.createdDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject,
      jobPlanName:
        editData.jobPlanName !== "" &&
        editData.jobPlanName !== undefined &&
        editData.jobPlanName !== null
          ? editData.jobPlanName
          : "",
      workTypeId:
        editData.workTypeId !== "" &&
        editData.workTypeId !== undefined &&
        editData.workTypeId !== null
          ? editData.workTypeId
          : null,
      // workTypeId: (() => {
      //   try {
      //     const hasPmCode = edit && editData && editData.pmCode;
      //     if (hasPmCode) {
      //       return pmWorkTypeId || (editData.workTypeId || worktypCM);
      //     }
      //     return editData.workTypeId !== "" && editData.workTypeId !== undefined && editData.workTypeId !== null
      //       ? editData.workTypeId
      //       : worktypCM;
      //   } catch (e) {
      //     return worktypCM;
      //   }
      // })(),
      workCenterId: getValidWorkCenterId(
        workCenters,
        editData.workCenterId !== "" &&
          editData.workCenterId !== undefined &&
          editData.workCenterId !== null
          ? editData.workCenterId
          : "",
      ),
      followUpWorkOrderId:
        editData.followUpWorkOrderId !== "" &&
        editData.followUpWorkOrderId !== undefined &&
        editData.followUpWorkOrderId !== null
          ? editData.followUpWorkOrderId
          : null,
    }),
    [
      edit,
      editData,
      siteInfoDetail.siteId,
      pmWorkTypeId,
      worktypCM,
      workCenters,
    ],
  );

  const validationSchema = Yup.object().shape({
    workOrderName: Yup.string().required("Work Order Name is required"),
    locationId: Yup.string().required("Location is required"),
    assetId: Yup.string().required("Asset is required"),
    //status: Yup.string().required('Status is required'),
    // failureClassId: Yup.string().required("Failure Class is required"),
    priorityId: Yup.string().required("Priority is required"),
    //  problemId: Yup.string().required('Problem is required'),

    //  jobPlanId: Yup.string().required('Job Plan ID is required'),
    workCenterId: Yup.string().required("Work Responsible is required"),
    // actualStartDate: Yup.date().required('Actual Start Date is required'),
    // actualEndDate: Yup.date().required('Actual End Date is required'),
    targetStartDate: Yup.date().required("Target Start Date is required"),
    targetEndDate: Yup.date()
      .required("Target End Date is required")
      .min(
        Yup.ref("targetStartDate"),
        "Target End Date must be after Target Start Date",
      ),
    // plannedStartDate: Yup.date().required("Planned Start Date is required"),
    // plannedEndDate: Yup.date().required("Planned End Date is required"),
    // duration: Yup.string().required('Duration is required'),
    // earliestStartDate: Yup.date().required('Earliest Start Date is required'),
    // latestEndDate: Yup.date().required('Latest End Date is required'),

    // createdDate: Yup.date().required('Created Date is required'),
    // responsiblePersonId: Yup.string().required(
    //   "Responsible Person ID is required"
    // ),

    workTypeId: Yup.string().required("Work Type is required"),
  });

  //  const onSubmit=async(values)=>{
  //    console.log(values)
  //    setLoading(true)
  //   // jobPlanIden(values.jobPlanId,"fcc97ac9-741a-459c-b3d8-9afb210f9d69")
  //    const createWO=masterAPI["workOrder"].create
  //    const editWO=masterAPI["workOrder"].update
  //    if(edit){
  //     const putData={
  //       id:editData.id,
  //       ...values
  //     }
  //     console.log(putData)
  //    await axiosPrivate.put(`${editWO}`,putData).then(res=>{
  //       console.log(res)
  //       // navigate(`/workorderview?id=${res.data.id}`)
  //       navigate(`/workOrder`)
  //       setLoading(false)
  //       // console.log(values.jobPlanId)
  //       // jobPlanIden(values.jobPlanId,"fcc97ac9-741a-459c-b3d8-9afb210f9d69")

  //      }).catch(e=>{
  //       setLoading(false)
  //       console.log(e,"create wo")
  //      })
  //    }else{
  //     const splitData=auto.asset.split("-")
  //     const postSysPro={
  //       JobDescription: values.description,
  //       AssetCode: splitData[0]+"-"+splitData[1],
  //       AssetName: splitData[2],
  //       CreateDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
  //       TargetStartDate: values.targetStartDate,
  //       TargetEndDate: values.targetEndDate
  //       }

  //       console.log(splitData,postSysPro)
  //    await axiosPrivate.post('https://connector.orienseam.com/api/SysProXml/PostWorkOrder',postSysPro).then(async(res)=>{
  //       const postData={
  //         ...values,
  //         notes:res.data
  //       }

  //     await axiosPrivate.post(`${createWO}`,postData).then(res=>{
  //       console.log(res)
  //       navigate(`/workorderview?id=${res.data.id}`)
  //       setLoading(false)
  //       // console.log(values.jobPlanId)
  //       // jobPlanIden(values.jobPlanId,"fcc97ac9-741a-459c-b3d8-9afb210f9d69")

  //      }).catch(e=>{
  //       setLoading(false)
  //       console.log(e,"create wo")
  //      })
  //     }).catch(e=>{
  //       console.log("syspro error",e)
  //     })

  //   //   const postData={
  //   //     ...values,
  //   //     notes:"test"
  //   //   }

  //   //  axiosPrivate.post(`${createWO}`,postData).then(res=>{
  //   //   console.log(res)
  //   //   navigate(`/workorderview?id=${res.data.id}`)
  //   //   setLoading(false)
  //   //   // console.log(values.jobPlanId)
  //   //   // jobPlanIden(values.jobPlanId,"fcc97ac9-741a-459c-b3d8-9afb210f9d69")

  //   //  }).catch(e=>{
  //   //   setLoading(false)
  //   //   console.log(e,"create wo")
  //   //  })
  //   }

  //  }
  // const onSubmit = async (values) => {
  //   console.log(values);
  //   setLoading(true);

  //   const createWO = masterAPI["workOrder"].create;
  //   const editWO = masterAPI["workOrder"].update;

  //   if (edit) {
  //     const putData = {
  //       id: editData.id,
  //       ...values,
  //     };
  //     console.log(putData);
  //     await axiosPrivate
  //       .put(`${editWO}`, putData)
  //       .then((res) => {
  //         console.log(res);
  //         navigate(`/workOrder`);
  //         setLoading(false);
  //       })
  //       .catch((e) => {
  //         setLoading(false);
  //         console.log(e, "create wo");
  //       });
  //   } else {
  //     const splitData = auto.asset.split("-");
  //     const postSysPro = {
  //       JobDescription: values.description,
  //       AssetCode: splitData[0] + "-" + splitData[1],
  //       AssetName: splitData[2],
  //       CreateDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
  //       TargetStartDate: values.targetStartDate,
  //       TargetEndDate: values.targetEndDate,
  //     };

  //     console.log(splitData, postSysPro);

  //     // Check if useSysProInventory is true before hitting SysPro API
  //     if (siteInfoDetail.useSysProInventory) {
  //       await axiosPrivate
  //         .post(
  //           "https://connector.orienseam.com/api/SysProXml/PostWorkOrder",
  //           postSysPro
  //         )
  //         .then(async (res) => {
  //           const postData = {
  //             ...values,
  //             notes: res.data,
  //           };

  //           await axiosPrivate
  //             .post(`${createWO}`, postData)
  //             .then((res) => {
  //               console.log(res);
  //               navigate(`/workorderview?id=${res.data.id}`);
  //               setLoading(false);
  //             })
  //             .catch((e) => {
  //               setLoading(false);
  //               console.log(e, "create wo");
  //             });
  //         })
  //         .catch((e) => {
  //           setLoading(false);
  //           console.log("syspro error", e);
  //         });
  //     } else {
  //       // Directly create work order without SysPro
  //       const postData = {
  //         ...values,
  //       };

  //       await axiosPrivate
  //         .post(`${createWO}`, postData)
  //         .then((res) => {
  //           console.log(res);
  //           navigate(`/workorderview?id=${encode(res.data.id)}`);
  //           toast.success(res.data.message);
  //           setLoading(false);
  //         })
  //         .catch((e) => {
  //           setLoading(false);
  //           console.log(e, "create wo");
  //         });
  //     }
  //   }
  // };
  // const onSubmit = async (values) => {
  //   console.log(values);

  //   // 🟡 Find selected asset from asset list
  //   const selectedAsset = assetsList.find((a) => a.id === values.assetId);

  //   if (selectedAsset && selectedAsset.expirationDate) {
  //     const expDate = new Date(selectedAsset.expirationDate);
  //     const today = new Date();

  //     // 🟢 If asset is still under warranty (future expiration date)
  //     if (expDate > today) {
  //       const confirmProceed = window.confirm(
  //         "The selected asset is under warranty. Do you want to proceed with creating the Work Order?"
  //       );

  //       if (!confirmProceed) {
  //         // user canceled → stop here
  //         return;
  //       }
  //     }
  //   }

  //   // 🟣 Continue your existing logic
  //   setLoading(true);

  //   const createWO = masterAPI["workOrder"].create;
  //   const editWO = masterAPI["workOrder"].update;

  //   if (edit) {
  //     const putData = {
  //       id: editData.id,
  //       ...values,
  //     };
  //     console.log(putData);
  //     await axiosPrivate
  //       .put(`${editWO}`, putData)
  //       .then((res) => {
  //         console.log(res);
  //         navigate(`/workOrder`);
  //         setLoading(false);
  //       })
  //       .catch((e) => {
  //         setLoading(false);
  //         console.log(e, "update wo");
  //       });
  //   } else {
  //     const splitData = auto.asset.split("-");
  //     const postSysPro = {
  //       JobDescription: values.description,
  //       AssetCode: splitData[0] + "-" + splitData[1],
  //       AssetName: splitData[2],
  //       CreateDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
  //       TargetStartDate: values.targetStartDate,
  //       TargetEndDate: values.targetEndDate,
  //     };

  //     if (siteInfoDetail.useSysProInventory) {
  //       await axiosPrivate
  //         .post(
  //           "https://connector.orienseam.com/api/SysProXml/PostWorkOrder",
  //           postSysPro
  //         )
  //         .then(async (res) => {
  //           const postData = {
  //             ...values,
  //             notes: res.data,
  //           };

  //           await axiosPrivate
  //             .post(`${createWO}`, postData)
  //             .then((res) => {
  //               console.log(res);
  //               navigate(`/workorderview?id=${res.data.id}`);
  //               setLoading(false);
  //             })
  //             .catch((e) => {
  //               setLoading(false);
  //               console.log(e, "create wo");
  //             });
  //         })
  //         .catch((e) => {
  //           setLoading(false);
  //           console.log("syspro error", e);
  //         });
  //     } else {
  //       const postData = {
  //         ...values,
  //       };

  //       await axiosPrivate
  //         .post(`${createWO}`, postData)
  //         .then((res) => {
  //           console.log(res);
  //           navigate(`/workorderview?id=${encode(res.data.id)}`);
  //           toast.success(res.data.message);
  //           setLoading(false);
  //         })
  //         .catch((e) => {
  //           setLoading(false);
  //           console.log(e, "create wo");
  //         });
  //     }
  //   }
  // };
  const onSubmit = async (values) => {
    console.log(values);

    const selectedWorkType = workType.find(
      (wt) => wt.value === values.workTypeId,
    );
    const isEmOrCm =
      selectedWorkType &&
      (selectedWorkType.text === "CM" || selectedWorkType.text === "EM");
    const hasNoFailureClass =
      !values.failureClassId ||
      values.failureClassId === "" ||
      values.failureClassId === null ||
      values.failureClassId === undefined;

    if (isEmOrCm && hasNoFailureClass) {
      toast.warning(
        ({ closeToast }) => (
          <Box display="flex" flexDirection="column" gap={1}>
            <Typography variant="body2">
              You have not selected a Failure Class. Do you wish to proceed
              without it?
            </Typography>

            <Box display="flex" justifyContent="flex-end" gap={1}>
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={async () => {
                  closeToast();
                  await checkWarrantyAndProceed(values);
                }}
              >
                Proceed
              </Button>

              <Button
                size="small"
                variant="outlined"
                color="inherit"
                onClick={closeToast}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        ),
        {
          autoClose: false,
          closeOnClick: false,
          style: {
            backgroundColor: "#fff",
            color: "#000",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
          },
        },
      );
      return;
    }
    await checkWarrantyAndProceed(values);
  };

  const checkWarrantyAndProceed = async (values) => {
    const selectedAsset = assetsList.find((a) => a.id === values.assetId);

    if (selectedAsset && selectedAsset.expirationDate) {
      const expDate = new Date(selectedAsset.expirationDate);
      const today = new Date();

      // 🟢 If asset is still under warranty
      if (expDate > today) {
        toast.info(
          ({ closeToast }) => (
            <Box display="flex" flexDirection="column" gap={1}>
              <Typography variant="body2">
                The selected asset is under warranty. Do you want to proceed?
              </Typography>

              <Box display="flex" justifyContent="flex-end" gap={1}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    closeToast();
                    await handleWorkOrderCreate(values);
                  }}
                >
                  Proceed
                </Button>

                <Button
                  size="small"
                  variant="outlined"
                  color="inherit"
                  onClick={closeToast}
                >
                  Cancel
                </Button>
              </Box>
            </Box>
          ),
          {
            autoClose: false,
            closeOnClick: false,
            style: {
              backgroundColor: "#fff", // ← 🔹 white background
              color: "#000", // ← 🔹 black text
              borderRadius: "8px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
            },
          },
        );
        return; // Stop here until user clicks Proceed
      }
    }

    // proceed normally if not under warranty
    await handleWorkOrderCreate(values);
  };

  const handleWorkOrderCreate = async (values) => {
    setLoading(true);

    const createWO = masterAPI["workOrder"].create;
    const editWO = masterAPI["workOrder"].update;

    // Convert date fields from local time to UTC (except actualStartDate and actualEndDate)
    const convertedValues = {
      ...values,
      targetStartDate: values.targetStartDate
        ? toUTC(values.targetStartDate).utcISOString
        : values.targetStartDate,
      targetEndDate: values.targetEndDate
        ? toUTC(values.targetEndDate).utcISOString
        : values.targetEndDate,
      plannedStartDate: values.plannedStartDate
        ? toUTC(values.plannedStartDate).utcISOString
        : values.plannedStartDate,
      plannedEndDate: values.plannedEndDate
        ? toUTC(values.plannedEndDate).utcISOString
        : values.plannedEndDate,
      earliestStartDate: values.earliestStartDate
        ? toUTC(values.earliestStartDate).utcISOString
        : values.earliestStartDate,
      latestEndDate: values.latestEndDate
        ? toUTC(values.latestEndDate).utcISOString
        : values.latestEndDate,
      createdDate: values.createdDate
        ? toUTC(values.createdDate).utcISOString
        : values.createdDate,
      // stopBeginDate: values.stopBeginDate
      //   ? toUTC(values.stopBeginDate).utcISOString
      //   : values.stopBeginDate,
    };

    if (edit) {
      const putData = {
        id: editData.id,
        ...convertedValues,
      };
      await axiosPrivate
        .put(`${editWO}`, putData)
        .then((res) => {
          navigate(`/workOrder`);
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          console.log(e, "update wo");
        });
    } else {
      const splitData = auto.asset.split("-");
      const postSysPro = {
        JobDescription: values.description,
        AssetCode: splitData[0] + "-" + splitData[1],
        AssetName: splitData[2],
        CreateDate: getCurrentInTimeZone().dayjsObject,
        TargetStartDate: convertedValues.targetStartDate,
        TargetEndDate: convertedValues.targetEndDate,
      };

      if (siteInfoDetail.useSysProInventory) {
        await axiosPrivate
          .post(
            "https://connector.orienseam.com/api/SysProXml/PostWorkOrder",
            postSysPro,
          )
          .then(async (res) => {
            const postData = {
              ...convertedValues,
              notes: res.data,
            };

            await axiosPrivate
              .post(`${createWO}`, postData)
              .then((res) => {
                navigate(`/workorderview?id=${res.data.id}`);
                setLoading(false);
              })
              .catch((e) => {
                setLoading(false);
                console.log(e, "create wo");
              });
          })
          .catch((e) => {
            setLoading(false);
            console.log("syspro error", e);
          });
      } else {
        const postData = {
          ...convertedValues,
        };
        console.log("postData", postData);

        await axiosPrivate
          .post(`${createWO}`, postData)
          .then((res) => {
            navigate(`/workorderview?id=${encode(res.data.id)}`);
            // toast.success(res.data.message);
            setLoading(false);
          })
          .catch((e) => {
            setLoading(false);
            // toast.error(e.response.data.failureMessage);
            console.log(e, "create wo");
          });
      }
    }
  };

  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  const handleFailureProblem = async (fcid) => {
    const pcLink = masterAPI["problems"].problembyFailureClass;
    await axiosPrivate
      .get(`${pcLink}/${fcid}`)
      .then((res) => {
        console.log(res.data.result);
        setProblemCode(res.data.result);
      })
      .catch((e) => {
        setProblemCode([]);
        console.log(e, "Problem Create Wo");
      });
  };
  return (
    <Box sx={{ p: 1 }}>
      <Box
        // sx={{
        //   display: "flex",
        //   alignItems: "center",
        //   justifyContent: "space-between",
        //   width: "100%",
        // }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          mb: "1rem",
          gap: "1rem",
        }}
      >
        <Grid>
          <Link to="/workOrder">
            <IconButton>
              <ArrowBack />
            </IconButton>
          </Link>
        </Grid>
        <Typography
          sx={{
            // color: color.masterDialogTitleColor,
            // fontSize: color.masterDialogFontSize,
            textAlign: "left",
            flex: 1,
            fontSize: color.AssetTitlesize,
            fontWeight: color.sideFontWeightAsset,
          }}
        >
          {edit
            ? editData.code + "-" + editData.workOrderName
            : " New Work Order"}
        </Typography>
      </Box>
      <Formik
        innerRef={formikRef}
        enableReinitialize={edit}
        initialValues={initialValue}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ handleChange, setFieldValue, values, errors }) => {
          return (
            <Form>
              <TabContext value={value}>
                <Box
                  sx={{
                    ".css-hg18dx-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                      color: color.TabLabelcolor,
                      // p: 0.5,
                    },
                    display: "flex",
                    justifyContent: "space-between",
                    width: "90%",
                  }}
                >
                  <TabList
                    // onChange={handleChange}
                    aria-label="lab API tabs example"
                    TabIndicatorProps={{
                      sx: {
                        backgroundColor: color.TabLabelcolor,
                        height: "3px",
                      },
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                  >
                    <Tab
                      label="General"
                      value="1"
                      sx={{ textTransform: "none" }}
                    />
                    <Tab
                      label="Work Plan"
                      value="2"
                      sx={{ textTransform: "none" }}
                    />
                    <Tab
                      label="Work Assignment"
                      value="3"
                      sx={{ textTransform: "none" }}
                    />

                    <Tab
                      label="Completion"
                      value="4"
                      sx={{ textTransform: "none" }}
                    />
                    {/* <Tab
                    label="Costing"
                    value="5"
                    sx={{ textTransform: "none" }}
                  /> */}
                  </TabList>
                </Box>
                <Box sx={{ mt: "1rem" }}>
                  <TabPanel value="1" sx={{ p: 1 }}>
                    <Grid container gap={"1.5rem"}>
                      <Grid
                        item
                        xs={5.5}
                        sx={{
                          boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                          p: 1.5,
                          backgroundColor: "white",
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              color: color.masterDialogTitleColor,
                              fontSize: color.masterDialogFontSize,
                            }}
                          >
                            {" "}
                            Basic{" "}
                          </Typography>
                          <Divider
                            sx={{
                              border: "1px solid rgb(0 0 0 / 17%)",
                              mb: "15px",
                            }}
                          />
                        </Box>
                        <Grid container spacing={"1rem"}>
                          <Grid item xs={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Work Order Name
                            </Typography>
                            <Field
                              as={TextField}
                              size={"small"}
                              type="text"
                              name="workOrderName"
                              variant="standard"
                              placeholder="Enter Work Order Name"
                              fullWidth
                              sx={{
                                ".MuiInputBase-input": {
                                  // letterSpacing: "0.2rem",

                                  "&::placeholder": {
                                    // color: "green",
                                    opacity: 1,
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  },
                                },
                              }}
                            />
                            <ErrorMessage name="workOrderName">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Description
                            </Typography>
                            <Field
                              as={TextField}
                              size={"small"}
                              type="text"
                              name="description"
                              variant="standard"
                              placeholder="Enter Description"
                              fullWidth
                              sx={{
                                ".MuiInputBase-input": {
                                  // letterSpacing: "0.2rem",

                                  "&::placeholder": {
                                    // color: "green",
                                    opacity: 1,
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  },
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Asset
                            </Typography>
                            {/* <Field
                as={Select}
                // label={"Select"}
                size={"small"}
                type="text"
                name="assetId"
                variant="standard"
                fullWidth
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
               renderValue={values.assetId !== "" ? undefined : () =><Typography sx={{  color: color.placeholderColor,
                fontSize: "13px",}} >Select</Typography> }
              >

                {assetId.map((id, i) => (
                  <MenuItem value={id.id}>{id.assetCode+"-"+id.assetName}</MenuItem>
                ))}
              </Field> */}

                            <Field
                              name="assetId"
                              //  value={autoValue}
                              // value={values.assetName.code+"_"+values.assetName.assetName}
                              inputValue={auto.asset}
                              component={Autocomplete}
                              filterOptions={filterOptions}
                              loading={assetId.length === 0 && loading}
                              options={assetId}
                              PaperComponent={CustomPaper}
                              getOptionLabel={(option) =>
                                option.code + " - " + option.assetName || option
                              }
                              freeSolo
                              onChange={(event, value) => {
                                if (value) {
                                  console.log(value);
                                  setFieldValue("assetId", value.id);
                                  setFieldValue("locationId", value.locationId);
                                  setFieldValue(
                                    "responsiblePersonId",
                                    value.maintenance_responsible_personid,
                                  );
                                  setFieldValue(
                                    "failureClassId",
                                    value.failureClassesId,
                                  );
                                  setFieldValue(
                                    "priorityId",
                                    value.priorityId || null,
                                  );
                                  setAuto({
                                    ...auto,
                                    asset: value.code + " - " + value.assetName,
                                    location:
                                      value.locationCode +
                                      " - " +
                                      value.locationName,
                                  });
                                  setAssetInfo(value);
                                  handleFailureProblem(value.failureClassesId);
                                } else {
                                  setFieldValue("assetId", null);
                                  setFieldValue("locationId", null);
                                  // setFieldValue("failureClassId",null)
                                  setAuto({ ...auto, asset: "", location: "" });
                                  setAssetInfo({});
                                  setProblemCode([]);
                                }
                              }}
                              onInputChange={(e, v) => {
                                setAuto({ ...auto, asset: v });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="assetId"
                                  placeholder="Search Asset"
                                  onChange={handleChange}
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <React.Fragment>
                                        {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                        {assetId.length === 0 && loading ? (
                                          <CircularProgress
                                            color="inherit"
                                            size={20}
                                          />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </React.Fragment>
                                    ),
                                  }}
                                />
                              )}
                            >
                              {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                            </Field>
                            <ErrorMessage name="assetId">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Location
                            </Typography>
                            {/* <Field
                as={Select}
                // label={"Select"}
                size={"small"}
                type="text"
                name="locationId"
                variant="standard"
                fullWidth
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
               renderValue={values.locationId !== "" ? undefined : () =><Typography sx={{  color: color.placeholderColor,
                fontSize: "13px",}} >Select</Typography> }
              >

                {locationId.map((id, i) => (
                  <MenuItem value={id.id}>{id.locationCode+"-"+id.locationName}</MenuItem>
                ))}
              </Field> */}
                            <Field
                              name="locationId"
                              //  value={autoValue}
                              // value={values.assetName.code+"_"+values.assetName.assetName}
                              value={
                                locationId.find(
                                  (loc) => loc.id === values.locationId,
                                ) || null
                              }
                              inputValue={auto.location}
                              readOnly={
                                assetInfo.locationId !== undefined &&
                                assetInfo !== null
                              }
                              component={Autocomplete}
                              filterOptions={filterOptions}
                              loading={locationId.length === 0 && loading}
                              options={locationId}
                              PaperComponent={CustomPaper}
                              getOptionLabel={(option) =>
                                option.code + " - " + option.locationName ||
                                option
                              }
                              freeSolo
                              onChange={async (event, value) => {
                                if (value) {
                                  console.log(value);
                                  const assetByLocation =
                                    masterAPI["assets"].assetByLocation;
                                  await axiosPrivate
                                    .get(`${assetByLocation}/${value.id}`)
                                    .then((res) => {
                                      setAssetId(res.data.result);
                                    })
                                    .catch((e) => {
                                      setAssetId([]);
                                      console.log(e, "error");
                                    });
                                  setFieldValue("locationId", value.id);
                                  setAuto({
                                    ...auto,
                                    asset: "",
                                    location:
                                      value.code + " - " + value.locationName,
                                  });
                                } else {
                                  setFieldValue("locationId", null);
                                  setAuto({ ...auto, location: "", asset: "" });
                                  getData();
                                  // setFieldValue("failureClassId",null)
                                }
                              }}
                              onInputChange={(e, v) => {
                                setAuto({ ...auto, location: v });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="locationId"
                                  placeholder="Search location"
                                  onChange={handleChange}
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <React.Fragment>
                                        {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                        {locationId.length === 0 &&
                                        loading === 0 ? (
                                          <CircularProgress
                                            color="inherit"
                                            size={20}
                                          />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </React.Fragment>
                                    ),
                                  }}
                                />
                              )}
                            >
                              {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                            </Field>
                            <ErrorMessage name="locationId">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>

                          <Grid item xs={6} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Follow Up Work Order
                            </Typography>
                            <Field
                              name="followUpWorkOrderId"
                              value={
                                workOrderByStatus.find(
                                  (wo) => wo.id === values.followUpWorkOrderId,
                                ) || null
                              }
                              component={Autocomplete}
                              filterOptions={filterOptions}
                              loading={
                                workOrderByStatus.length === 0 && loading
                              }
                              options={workOrderByStatus}
                              PaperComponent={CustomPaper}
                              getOptionLabel={(option) => option.text || option}
                              freeSolo
                              onChange={(event, value) => {
                                if (value) {
                                  setFieldValue(
                                    "followUpWorkOrderId",
                                    value.value,
                                  );
                                } else {
                                  setFieldValue("followUpWorkOrderId", null);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="followUpWorkOrderId"
                                  placeholder="Search Work Order"
                                  onChange={handleChange}
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <React.Fragment>
                                        {workOrderByStatus.length === 0 &&
                                        loading ? (
                                          <CircularProgress
                                            color="inherit"
                                            size={20}
                                          />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </React.Fragment>
                                    ),
                                  }}
                                />
                              )}
                            ></Field>
                          </Grid>

                          <Grid item xs={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Site
                            </Typography>
                            {/* <Field
                as={TextField}
                size={"small"}
                type="text"
                name="siteId"
                variant="standard"
                placeholder="Enter siteId"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              /> */}
                            <Field
                              as={Select}
                              // label={"Select"}
                              size={"small"}
                              type="text"
                              name="siteId"
                              variant="standard"
                              readOnly
                              fullWidth
                              displayEmpty
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "40vh" } },
                              }}
                              renderValue={
                                values.siteId !== null
                                  ? undefined
                                  : () => (
                                      <Typography
                                        sx={{
                                          color: color.placeholderColor,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Select
                                      </Typography>
                                    )
                              }
                            >
                              <MenuItem value={`${siteInfoDetail.siteId}`}>
                                {siteInfoDetail.siteName}
                              </MenuItem>
                            </Field>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              GL Account
                            </Typography>
                            <Field
                              as={TextField}
                              size={"small"}
                              type="text"
                              name="glAccount"
                              variant="standard"
                              placeholder="Enter GL Account "
                              fullWidth
                              sx={{
                                ".MuiInputBase-input": {
                                  // letterSpacing: "0.2rem",

                                  "&::placeholder": {
                                    // color: "green",
                                    opacity: 1,
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  },
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={5.5}
                        sx={{
                          boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                          p: 1.5,
                          backgroundColor: "white",
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              color: color.masterDialogTitleColor,
                              fontSize: color.masterDialogFontSize,
                            }}
                          >
                            {" "}
                            Job Info
                          </Typography>
                          <Divider
                            sx={{
                              border: "1px solid rgb(0 0 0 / 17%)",
                              mb: "15px",
                            }}
                          />
                        </Box>
                        <Grid container spacing={"1rem"}>
                          <Grid item xs={6} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Job Status
                            </Typography>
                            <Field
                              as={Select}
                              // label={"Select"}
                              readOnly={!edit}
                              size={"small"}
                              type="text"
                              name="status"
                              variant="standard"
                              fullWidth
                              displayEmpty
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "40vh" } },
                              }}
                              renderValue={
                                values.status !== ""
                                  ? undefined
                                  : () => (
                                      <Typography
                                        sx={{
                                          color: color.placeholderColor,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Select
                                      </Typography>
                                    )
                              }
                            >
                              {JPStatus.map((id) => (
                                <MenuItem value={id.value}>{id.text}</MenuItem>
                              ))}
                            </Field>
                            {/* <ErrorMessage name="status">
                  {(error) => <ErrorProps>{error}</ErrorProps>}
                </ErrorMessage> */}
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Work Type
                            </Typography>
                            <Field
                              as={Select}
                              size={"small"}
                              type="text"
                              name="workTypeId"
                              variant="standard"
                              fullWidth
                              disabled={Boolean(
                                edit && editData && editData.pmCode,
                              )}
                              displayEmpty
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "40vh" } },
                              }}
                              renderValue={
                                values.workTypeId !== ""
                                  ? undefined
                                  : () => (
                                      <Typography
                                        sx={{
                                          color: color.placeholderColor,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Select
                                      </Typography>
                                    )
                              }
                            >
                              {workType.map((id) => (
                                <MenuItem key={id.value} value={id.value}>
                                  {id.text}
                                </MenuItem>
                              ))}
                            </Field>
                            <ErrorMessage name="workTypeId">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>

                          {/* <Grid item xs={6} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
               Job Priority
                </Typography>
              <Field
                as={Select}
                // label={"Select"}
                size={"small"}
                type="text"
                name="priority"
                variant="standard"
                fullWidth
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
               renderValue={values.priority !== "" ? undefined : () =><Typography sx={{  color: color.placeholderColor,
                fontSize: "13px",}} >Select</Typography> }
              >

                {priorityJob.map((id, i) => (
                  <MenuItem value={id.value}>{id.text}</MenuItem>
                ))}
              </Field>
            </Grid> */}
                          {/* <Grid item xs={6} >
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Failure Class
                </Typography>
              <Field
                as={TextField}
                size={"small"}
                type="text"
                name="failureClassName"
                variant="standard"
                placeholder="Enter Failure class"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Grid> */}
                          <Grid item xs={6} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Failure Class
                            </Typography>
                            <Field
                              as={Select}
                              // label={"Select"}
                              size={"small"}
                              type="text"
                              name="failureClassId"
                              variant="standard"
                              fullWidth
                              displayEmpty
                              readOnly={
                                assetInfo.failureClassesId !== undefined &&
                                assetInfo.failureClassesId !== null
                              }
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "40vh" } },
                              }}
                              onChange={(e) => {
                                setFieldValue("failureClassId", e.target.value);
                                handleFailureProblem(e.target.value);
                              }}
                              renderValue={
                                values.failureClassId !== null &&
                                values.failureClassId !== undefined
                                  ? undefined
                                  : () => (
                                      <Typography
                                        sx={{
                                          color: color.placeholderColor,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Select
                                      </Typography>
                                    )
                              }
                            >
                              {failureClass.map((id) => (
                                <MenuItem value={id.id}>
                                  {id.failureClassName}
                                </MenuItem>
                              ))}
                            </Field>
                            <ErrorMessage name="failureClassId">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Problem Code
                            </Typography>
                            <Field
                              as={Select}
                              // label={"Select"}
                              size={"small"}
                              type="text"
                              name="problemId"
                              variant="standard"
                              fullWidth
                              displayEmpty
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "40vh" } },
                              }}
                              renderValue={
                                values.problemId !== null
                                  ? undefined
                                  : () => (
                                      <Typography
                                        sx={{
                                          color: color.placeholderColor,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Select
                                      </Typography>
                                    )
                              }
                            >
                              {probleCode.map((id) => (
                                <MenuItem value={id.id}>
                                  {id.code + " - " + id.problemName}
                                </MenuItem>
                              ))}
                            </Field>
                            <ErrorMessage name="problemId">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Job Priority
                            </Typography>
                            <Field
                              as={Select}
                              // label={"Select"}
                              size={"small"}
                              type="text"
                              name="priorityId"
                              variant="standard"
                              fullWidth
                              readOnly={
                                edit ? false : editData.priorityId !== undefined
                              }
                              displayEmpty
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "40vh" } },
                              }}
                              renderValue={
                                values.priorityId !== null
                                  ? undefined
                                  : () => (
                                      <Typography
                                        sx={{
                                          color: color.placeholderColor,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Select
                                      </Typography>
                                    )
                              }
                            >
                              {priority.map((id) => (
                                <MenuItem value={id.id}>
                                  {id.priorityName}
                                </MenuItem>
                              ))}
                            </Field>
                            <ErrorMessage name="priorityId">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={5.5}
                        sx={{
                          boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                          p: 1.5,
                          backgroundColor: "white",
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              color: color.masterDialogTitleColor,
                              fontSize: color.masterDialogFontSize,
                            }}
                          >
                            {" "}
                            Planning
                          </Typography>
                          <Divider
                            sx={{
                              border: "1px solid rgb(0 0 0 / 17%)",
                              mb: "15px",
                            }}
                          />
                        </Box>
                        <Grid container spacing={"1.5rem"}>
                          <Grid item xs={12} md={12}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Job Plan ID
                            </Typography>
                            {/* <Field
            as={Select}
            // label={"Select"}
            size={"small"}
            type="text"
            name="jobPlanId"
            variant="standard"
            fullWidth
            displayEmpty
            MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
           renderValue={values.jobPlanId !== null ? undefined : () =><Typography sx={{  color: color.placeholderColor,
            fontSize: "13px",}} >Select</Typography> }
          >

            {jobPlan.map((id, i) => (
              <MenuItem value={id.id}>{id.jobPlanName}</MenuItem>
            ))}
          </Field> */}
                            <Field
                              name="jobPlanId"
                              //  value={autoValue}
                              value={values.jobPlanName}
                              component={Autocomplete}
                              disabled={editData.workTypeName === "PM"}
                              filterOptions={filterOptions}
                              loading={jobPlan.length === 0}
                              options={jobPlan}
                              PaperComponent={CustomPaper}
                              getOptionLabel={(option) =>
                                option.jobPlanName || option
                              }
                              freeSolo
                              onChange={(event, value) => {
                                if (value) {
                                  console.log(value);
                                  setFieldValue("jobPlanId", value.id);
                                  setFieldValue(
                                    "jobPlanName",
                                    value.jobPlanName,
                                  );
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  name="jobPlanId"
                                  placeholder="Search Job Plan"
                                  onChange={handleChange}
                                  variant="standard"
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <React.Fragment>
                                        {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                        {jobPlan.length === 0 ? (
                                          <CircularProgress
                                            color="inherit"
                                            size={20}
                                          />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </React.Fragment>
                                    ),
                                  }}
                                />
                              )}
                            >
                              {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                            </Field>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Actual Start Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  readOnly
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.actualStartDate !== null
                                      ? dayjs(values.actualStartDate)
                                      : values.actualStartDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom = moment(newValue.$d);
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue(
                                          "actualStartDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Target Start Date
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.targetStartDate !== null
                                      ? dayjs(values.targetStartDate)
                                      : values.targetStartDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        const dateTo = dateFrom.add(1, "day");
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue(
                                          "targetStartDate",
                                          dateFrom,
                                        );
                                        setFieldValue("targetEndDate", dateTo);
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                            <ErrorMessage name="targetStartDate">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Actual End Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              {/* <DemoContainer components={["DatePicker"]} > */}
                              <DemoItem>
                                <DateTimePicker
                                  ampm={false}
                                  readOnly
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.actualEndDate !== null
                                      ? dayjs(values.actualEndDate)
                                      : values.actualEndDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom = moment(newValue.$d);
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue(
                                          "actualEndDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                              {/* </DemoContainer> */}
                            </LocalizationProvider>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Target End Date
                            </Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.targetEndDate !== null
                                      ? dayjs(values.targetEndDate)
                                      : values.targetEndDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue(
                                          "targetEndDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                            <ErrorMessage name="targetEndDate">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                          {/* <Grid item xs={6}  sx={{".css-1pduc5x-MuiStack-root":{paddingTop:0,overflowX:{xs:"auto",lg:"hidden"},overflowY:"hidden"}}}>
        <Typography
              sx={{
                fontWeight: color.labelFontWeight,
                mb: color.labelmb,
                fontSize: color.labelFont,
                color: color.labelColor,
              }}
            >
                  Stop Begin Date
                </Typography>

                <LocalizationProvider dateAdapter={AdapterDayjs}  >

                    <DemoItem>
                    <DateTimePicker

                                  ampm={false}
                                   format="DD/MM/YYYY HH:mm"
                                   viewRenderers={{
                                     hours: renderTimeViewClock,
                                     minutes: renderTimeViewClock,
                                     seconds: renderTimeViewClock,
                                   }}

                      value={(values.stopBeginDate!==null?dayjs(values.stopBeginDate):values.stopBeginDate)}
                      // sx={{".css-1xhypcz-MuiStack-root":{
                      //   padding:0
                      // }}}

                      slotProps={{ textField: { size: "small",margin:"-8px 0 0 0" , variant:"standard",fullWidth:true } }}

                      fullWidth
                      onChange={(newValue) => {

                        console.log(newValue);
                        if (newValue !== null) {
                          if (`${newValue.$d}` !== "Invalid Date") {
                            const dateFrom = getDateWithOutUTC(newValue);
                            // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                            // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                            // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                            // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                         setFieldValue("stopBeginDate",dateFrom)
                          }
                        }
                      }} />
                      </DemoItem>

                </LocalizationProvider>
        </Grid> */}
                          <Grid
                            item
                            xs={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Planned Start Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.plannedStartDate !== null
                                      ? dayjs(values.plannedStartDate)
                                      : values.plannedStartDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue(
                                          "plannedStartDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                            <ErrorMessage name="plannedStartDate">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Planned End Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.plannedEndDate !== null
                                      ? dayjs(values.plannedEndDate)
                                      : values.plannedEndDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue(
                                          "plannedEndDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                            <ErrorMessage name="plannedEndDate">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Duration
                            </Typography>
                            <Field
                              as={TextField}
                              size={"small"}
                              type="text"
                              name="duration"
                              variant="standard"
                              placeholder="Enter Duration"
                              fullWidth
                              sx={{
                                ".MuiInputBase-input": {
                                  // letterSpacing: "0.2rem",

                                  "&::placeholder": {
                                    // color: "green",
                                    opacity: 1,
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  },
                                },
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Earliest Start Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  readOnly={editData.workTypeName === "PM"}
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.earliestStartDate !== null
                                      ? dayjs(values.earliestStartDate)
                                      : values.earliestStartDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue(
                                          "earliestStartDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              latest End Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  readOnly={editData.workTypeName === "PM"}
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.latestEndDate !== null
                                      ? dayjs(values.latestEndDate)
                                      : values.latestEndDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue(
                                          "latestEndDate",
                                          dateFrom,
                                        );
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={5.5}
                        sx={{
                          boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
                          p: 1.5,
                          backgroundColor: "white",
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              color: color.masterDialogTitleColor,
                              fontSize: color.masterDialogFontSize,
                            }}
                          >
                            {" "}
                            Responsibility
                          </Typography>
                          <Divider
                            sx={{
                              border: "1px solid rgb(0 0 0 / 17%)",
                              mb: "15px",
                            }}
                          />
                        </Box>
                        <Grid container spacing={"1.5rem"}>
                          {/* <Grid item xs={12} >
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                Request By
                </Typography>


          <Field
            as={Select}

            size={"small"}
            type="text"
            name="requestById"
            variant="standard"
            fullWidth
            displayEmpty
            MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
           renderValue={values.requestById !== "" ? undefined : () =><Typography sx={{  color: color.placeholderColor,
            fontSize: "13px",}} >Select</Typography> }
          >


               {labourData.map((id, i) => (
              <MenuItem value={id.id}>{id.labourName}</MenuItem>
            ))}
          </Field>

            </Grid> */}
                          <Grid
                            item
                            xs={12}
                            sx={{
                              ".css-1pduc5x-MuiStack-root": {
                                paddingTop: 0,
                                overflowX: { xs: "auto", lg: "hidden" },
                                overflowY: "hidden",
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Created Date
                            </Typography>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoItem>
                                <DateTimePicker
                                  ampm={false}
                                  format="DD/MM/YYYY HH:mm"
                                  readOnly
                                  viewRenderers={{
                                    hours: renderTimeViewClock,
                                    minutes: renderTimeViewClock,
                                    seconds: renderTimeViewClock,
                                  }}
                                  value={
                                    values.createdDate !== null
                                      ? dayjs(values.createdDate)
                                      : values.earliestStartDate
                                  }
                                  // sx={{".css-1xhypcz-MuiStack-root":{
                                  //   padding:0
                                  // }}}

                                  slotProps={{
                                    textField: {
                                      size: "small",
                                      margin: "-8px 0 0 0",
                                      variant: "standard",
                                      fullWidth: true,
                                    },
                                  }}
                                  fullWidth
                                  onChange={(newValue) => {
                                    console.log(newValue);
                                    if (newValue !== null) {
                                      if (`${newValue.$d}` !== "Invalid Date") {
                                        const dateFrom =
                                          getDateWithOutUTC(newValue);
                                        // const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                                        // const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                                        // const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                                        // const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                                        setFieldValue("createdDate", dateFrom);
                                      }
                                    }
                                  }}
                                />
                              </DemoItem>
                            </LocalizationProvider>
                          </Grid>
                          {/* <Grid item xs={12} md={12}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                Business Id
                </Typography>


          <Field
            as={Select}
            // label={"Select"}
            size={"small"}
            type="text"
            name="businessId"
            variant="standard"
            fullWidth
            displayEmpty
            MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
           renderValue={values.businessId !== "" ? undefined : () =><Typography sx={{  color: color.placeholderColor,
            fontSize: "13px",}} >Select</Typography> }
          >

            {businessData.map((id, i) => (
              <MenuItem value={id.id}>{id.businessName}</MenuItem>
            ))}
          </Field>

            </Grid> */}
                          <Grid item xs={12} md={12}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Work Responsible
                            </Typography>
                            <Field name="workCenterId">
                              {({ field, form }) => (
                                <Autocomplete
                                  options={workCenters.filter(
                                    (center) =>
                                      center.value &&
                                      String(center.text).toLowerCase() !==
                                        "none",
                                  )}
                                  getOptionLabel={(option) => option.text || ""}
                                  isOptionEqualToValue={(option, value) =>
                                    option.value === value.value
                                  }
                                  value={
                                    workCenters.find(
                                      (center) => center.value === field.value,
                                    ) || null
                                  }
                                  onChange={(_, newValue) => {
                                    form.setFieldValue(
                                      "workCenterId",
                                      newValue ? newValue.value : "",
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      size="small"
                                      placeholder="Select"
                                      //error={Boolean(form.touched.workCenterId && form.errors.workCenterId)}
                                      //helperText={form.touched.workCenterId && form.errors.workCenterId}
                                    />
                                  )}
                                  fullWidth
                                  disableClearable
                                />
                              )}
                            </Field>
                            <ErrorMessage name="workCenterId">
                              {(error) => <ErrorProps>{error}</ErrorProps>}
                            </ErrorMessage>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </TabPanel>
                </Box>
              </TabContext>
              <Grid
                container
                item
                xs={11.9}
                justifyContent={"flex-end"}
                gap="1rem"
              >
                <Button
                  onClick={handleCancel}
                  variant="contained"
                  sx={{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                    ":hover": {
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type={"submit"}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    textTransform: "none",
                    backgroundColor: loading
                      ? "default"
                      : color.TableButtonColor,
                    "&:hover": {
                      backgroundColor: loading
                        ? "default"
                        : color.buttonDisable,
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default CreateGeneral;
